<template>
    <div>
        <Form :model="formItem"  :label-width="85">
            <FormItem >
                <RadioGroup v-model="formItem.personnelScope" @on-change="getData">
                    <Radio  v-for="(item,index) in ScopeList" :key="index"   :label="item.code">{{item.value}}</Radio>
                </RadioGroup>
            </FormItem>
        </Form>
        <Form v-if="formItem.personnelScope=='3'">
            <FormItem >
                <TreePersonComponent :treeData="treeData"  ref="treeDataDom" @getTreeChecked="getTreeChecked"></TreePersonComponent>
                <Spin size="large" fix v-if="spinShow"></Spin>
                <div class="bottomBtn" slot="footer">
                </div>
            </FormItem>
        </Form>
        <Form v-if="formItem.personnelScope=='4'">
            <FormItem >
                <RadioGroup v-model="formItem.viewType"  @on-change="closeOther">
                    <Row style="margin-left: 100px;">
                        <Radio label="1"><Input :disabled="formItem.viewType=='2'" v-model="formItem.hrmView" style="width:180px;margin-right: 25px;"></Input>(HRM视图)</Radio>
                    </Row>
                    <Row style="margin-top:15px;margin-left: 100px;">
                        <Radio label="2"><Input :disabled="formItem.viewType=='1'" v-model="formItem.successView" style="width:180px;margin-right: 25px;"></Input> (success视图) </Radio>
                    </Row>
                </RadioGroup>
                <Spin size="large" fix v-if="spinShow"></Spin>
            </FormItem>
        </Form>
        <Form v-if="formItem.personnelScope=='5'">
            <FormItem label="列名：">
                <Row>
                    <Input v-model="formItem.columnName" style="width: 200px;"></Input>
                </Row>
                <Table style="margin-top: 15px;" border stripe :columns="rolesColumns" :data="rolesData" :loading="loading2" @on-select-cancel="handleCancel1"  @on-select="handleSelect1" @on-select-all="handleSelectAll1" @on-select-all-cancel="handleCancelSelectAll1">
                </Table>
                <Page style="margin-top: 20px; text-align: right" :total="total1" @on-change="pageChange1"/>
            </FormItem>
        </Form>
        <Form v-if="formItem.personnelScope=='6'" >
            <Row>
                <FormItem label="汇报线层级：" style="margin-left:85px" >
                    <Row>
                        <Select  v-model="formItem.levelNum" style="width: 240px;margin-right: 25px;" clearable>
                            <Option v-for="(item,index) in reportList" :key="index" :value="item.code">{{item.value}}</Option>
                        </Select>
                    </Row>
                </FormItem>
                <FormItem label="直线/虚线主管：">
                    <Row>
                        <Select  v-model="formItem.dirOrIndir" style="width: 240px;" clearable>
                            <Option v-for="(item,index) in dirOrIndirList" :key="index" :value="item.code">{{item.value}}</Option>
                        </Select>
                    </Row>
                </FormItem>
            </Row>
            <Spin size="large" fix v-if="spinShow"></Spin>
        </Form>
        <Row style="margin-top:15px">
            <Col span="24" style="text-align: center">
              <Button @click="cancel()">取消</Button>
              <Button @click="savePersonnelScope">保存</Button>
            </Col>
        </Row>
    </div>
</template>

<script>
import axios from 'axios'
import TreePersonComponent from './../components/TreePersonComponent'
export default {
    props:['PersonnelScope'],
    components:{
        TreePersonComponent,
    },
    data(){
        return{
            spinShow:false,
            roleId:"",
            treeData:[],
            updatedData:[],
            selectList:[],
            formItem:{
                personnelScope:"2",
                columnName:""
            },
            loading2:false,
            dirOrIndirList:[
                {
                    code : "0",
                    value:"直线"
                },
                {
                    code : "1",
                    value:"虚线"
                }
            ],
            reportList:[
                {
                    code:"1",
                    value:"一层"
                },
                {
                    code:"2",
                    value:"二层"
                },{
                    code:"3",
                    value:"三层"
                },{
                    code:"4",
                    value:"四层"
                },{
                    code:"5",
                    value:"五层"
                },{
                    code:"6",
                    value:"六层"
                },{
                    code:"7",
                    value:"七层"
                },{
                    code:"8",
                    value:"八层"
                },{
                    code:"9",
                    value:"九层"
                },{
                    code:"10",
                    value:"十层"
                },
            ],
            ScopeList:[
               {
                    code:"1",
                    value : "全员"
               },
            //    {
            //         code:"2",
            //         value : "组织架构(默认)"
            //    },
            //    {
            //         code:"3",
            //         value : "组织架构(可选)"
            //    },
               {
                    code:"4",
                    value : "视图"
               },
            //    {
            //         code:"5",
            //         value : "法人主体"
            //    },
               {
                    code:"6",
                    value : "汇报线"
               },
               {
                    code:"7",
                    value : "根据HRM查询分配人员范围"
               },
               {
                    code:"8",
                    value : "HRBP汇报线"
               },
            ],
            rolesColumns:[
              {
                type: 'selection',
                width: 60,
                align: 'center'
              },
              {
                title: "Code",
                key: "code",
                width:'320',
                align: "center",
              },
              {
                title: "Value",
                key: "name1",
                align: "center",
              },
              
            ],
            rolesData:[
                {
                    code:"TCM",
                    value:"TCM-法人主体"
                },
                {
                    code:"HV-CN",
                    value:"HV-CN-法人主体"
                }
            ],
            pageInfo1: {
              itemCount: 0,
              pageNo: 1,
              pageSize: 10,
            },
            total1:0,
        }
    },
    
    methods:{
        pageChange1(val){
          this.pageInfo1.pageNo = val;
          this.selectRole()
        },
        getData(){
            this.spinShow=true
            if(this.formItem.personnelScope=='3'){
                let obj={
                    roleId:this.roleId,
                }
                axios.post('/personnelScope/selectOrgPersonInfo',obj).then(res => {
                  if(res) {
                    this.treeData=res.organizationStructureList
                    this.$refs.treeDataDom.treeDataList=this.treeData
                    this.$refs.treeDataDom.toggleExpand(this.treeData,true)
                    this.getUpdatedData(res.organizationStructureList)
                  }
                  this.spinShow=false
                })
            }else if(this.formItem.personnelScope=='4'){
                this.formItem.viewType=""
                this.formItem.hrmView=""
                this.formItem.successView=""
                let obj={
                    roleId:this.roleId,
                }
                axios.post('/personnelScope/selectViewInfo',obj).then(res => {
                  if(res) {
                      this.formItem.viewType = res.viewType
                    if(res.viewType == '1'){
                        this.formItem.hrmView = res.viewName
                    }
                    if(res.viewType == '2'){
                        this.formItem.successView = res.viewName
                    }
                  }
                  console.log(this.formItem)
                  this.$forceUpdate()
                  this.spinShow=false
                })
            }else if(this.formItem.personnelScope=='5'){
                this.loading2=true
                this.selectList = []
                this.formItem.columnName=""
                this.pageInfo1.pageNo = 1
                this.total1 = 0
                let obj={
                  roleId: this.roleId,
                }
                axios.post("/personnelScope/selectLegalEntityList", obj).then((res1) => {
                  if(res1 && res1.length!=0){
                    this.selectList = res1.filter(item=>{
                      return item.beUsed == "1"
                    })
                    this.formItem.columnName = res1[0].columnName
                    const newMap = new Map();
                    this.selectList = this.selectList.filter(item => !newMap.has(item.code) && newMap.set(item.code, 1));
                    this.selectRole()
                    console.log(this.selectList)
                  }
                });
            }else if(this.formItem.personnelScope=='6'){
                this.formItem.levelNum = ""
                this.formItem.dirOrIndir=""
                let obj={
                  roleId: this.roleId,
                }
                axios.post("/personnelScope/selectReportList", obj).then((res1) => {
                        this.formItem.levelNum = res1 ? res1.levelNum : null
                        this.formItem.dirOrIndir = res1 ? res1.dirOrIndir : null
                        this.$forceUpdate()
                        this.spinShow=false
                });
            }
        },
        selectPersonnelScope(row){
            this.roleId = row.roleId
            this.formItem.personnelScope = null
            let obj={
                roleId: row.roleId           
            }
            axios.post("/roleMaster/selectAllRoleMasterInfo", obj).then((res1) => {
                this.formItem.personnelScope = res1[0].personnelScope
                this.getData();
            });
        },
        getUpdatedData(data){
            for(let i in data) {
                if (data[i].beUsed=='1') {
                    this.updatedData.push(data[i])
                } else {
                    if (data[i].children) {
                        this.getUpdatedData(data[i].children)
                    }
                }
            }
        },
        selectRole(){
          this.loading2 = true
          let Obj = {
            roleId: this.roleId,
            pageNo: this.pageInfo1.pageNo,
            pageSize: this.pageInfo1.pageSize,
          }
          axios.post("/personnelScope/selectLegalEntityList", Obj).then((res) => {
            if(res){
              this.rolesData = res.data
              this.total1 = Number(res.pageInfo.total)
              this.rolesData.forEach(item=>{
                if(item.beUsed == "1"){
                  item._checked = true
                }
              })
              const res1 = new Map();
              this.selectList = this.selectList.filter(item => !res1.has(item.code) && res1.set(item.code, 1));
              this.updateChecked1()
            }
            this.loading2 = false
          });
        },
        updateChecked1() {
          for (var i = 0; i < this.rolesData.length; i++) {
            this.rolesData[i]._checked = false;
            for (var j = 0; j < this.selectList.length; j++) {
              if (this.selectList[j].code === this.rolesData[i].code) {
                this.rolesData[i]._checked = true;
                this.selectList[j].beUsed = "1";
              }
            }
          }
        },
        getTreeChecked(array){
            this.updatedData=array
        },
        savePersonnelScope(){
            if(this.formItem.personnelScope == '3'){
                if(this.updatedData.length<=0){
                    return this.$Message.error("如选择组织架构(可选),必须勾选组织架构");
                }
            }
            if(this.formItem.personnelScope == '4'){
                if(!this.formItem.viewType){
                    return this.$Message.error("如选择视图,必须选择一种视图，并填写视图名称");
                }
                if(this.formItem.viewType == '1'){
                   if(this.formItem.hrmView == "" || !this.formItem.hrmView){
                     return this.$Message.error("必须填写视图名称")
                   } 
                } 
                if(this.formItem.viewType == '2'){
                   if(this.formItem.successView == "" || !this.formItem.successView){
                     return this.$Message.error("必须填写视图名称")
                   } 
                }
            }
            if(this.formItem.personnelScope == '5'){
                if(!this.formItem.columnName){
                    return this.$Message.error("必须填写列名")
                }
                if(this.selectList.length<=0){
                    return this.$Message.error("如选择法人主体，必须勾选内容")
                }
            }
            if(this.formItem.personnelScope == '6'){
                if(!this.formItem.levelNum){
                    return this.$Message.error("必须选择汇报线层级")
                }
                if(!this.formItem.dirOrIndir){
                    return this.$Message.error("必须选择直线/虚线主管")
                }
            }
            this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                    this.spinShow=true
                    let obj={
                        roleId : this.roleId,
                        personnelScope : this.formItem.personnelScope
                    }
                    axios.post("/personnelScope/updatePersonnelScope", obj).then((res1) => {
                        if(res1){
                            if(this.formItem.personnelScope != '4'){
                                this.$Message.success(this.$t('Save_Successful'))
                                this.spinShow=false
                                this.$emit('closePersonnelScope');
                            }
                        }
                        this.saveData()
                    });
                }
              })
        },
        saveData(){
            if(this.formItem.personnelScope == '3'){
                this.orgMasterSave()
            }else if(this.formItem.personnelScope=='4'){
                this.saveViewInfo()
            }else if(this.formItem.personnelScope=='5'){
                this.legalMasterSave()
            }else if(this.formItem.personnelScope=='6'){
                this.saveReport()
            }
        },
        saveReport(){
            let obj = {
                roleId : this.roleId,
                levelNum : this.formItem.levelNum,
                dirOrIndir : this.formItem.dirOrIndir
            }
            axios.post('/personnelScope/saveReportList',obj).then(res => {
            })
        },
        legalMasterSave(){
            this.selectList.forEach((item)=>{
              item.columnName = this.formItem.columnName
            })
            let json={
                roleId:this.roleId,
                legalEntityList:this.selectList
            }
            axios.post('/personnelScope/saveLegalEntityList',json).then(res => {})
        },
        orgMasterSave(){
            
            let json={
                roleId:this.roleId,
                organizationStructureList:this.updatedData
            }
            axios.post('/personnelScope/saveOrgPersonInfo',json).then(res => {})
        },
        saveViewInfo(){
            this.formItem.viewType == '1' ? this.formItem.viewName = this.formItem.hrmView : this.formItem.viewName = this.formItem.successView
            let json={
                roleId:this.roleId,
                ...this.formItem
            }
            axios.post('/personnelScope/saveViewInfo',json).then(res => {
                this.spinShow=false
                if(!res.data){
                    this.$Message.success(this.$t('Save_Successful'))
                    this.$emit('closePersonnelScope');
                }
                
            })
        },
        cancel(){
            this.treeData=[]
            this.$emit('closePersonnelScope');
        },
        closeOther(){
            this.formItem.viewType ? this.formItem.viewType == "1" ? this.$set(this.formItem,'successView',"") : this.$set(this.formItem,'hrmView',"") :  null
            this.$forceUpdate()
        },
        handleCancel1(selection, row) {
          let newProductData = this.selectList.filter(item => {
            return item.code !== row.code
          })
          this.selectList = newProductData
          console.log(this.selectList,111)
        },
        handleSelect1(selection, row) {
          this.selectList.push(row);
          console.log(this.selectList,111)
        },
        handleSelectAll1(selection) {
          selection.forEach(item => {
            this.selectList.push(item)
          });
          // 去重
          const res = new Map();
          this.selectList = this.selectList.filter(item => !res.has(item.code) && res.set(item.code, 1));
          console.log(this.selectList,111)
        },
        handleCancelSelectAll1(selection) {
          var flag = true
          let arr = []
          for (var i = 0; i < this.selectList.length; i++) {
            flag = true
            for (var j = 0; j < this.rolesData.length ; j++) {
              if (this.selectList[i].code == this.rolesData[j].code) {
                flag = false
                break;
              }
            }
            if(flag){
              arr.push(this.selectList[i])
            }
          }
          this.selectList = arr
          console.log(this.selectList,111)
        },
    },
}
</script>

<style scoped>
.treeBox {
    height: calc(100vh - 300px);
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/components/PersonnelScope.vue